import { useCallback } from "react";

export const useTableControls = ({ tableParams, setParams, fetchData }) => {
  const handlePaginationChange = useCallback(
    (current, pageSize) => {
      // Обработчик для программного изменения пагинации
      // Используется когда нужно явно задать номер страницы и размер
      // (например, при фильтрации или поиске)

      // При изменении pageSize сбрасываем страницу на 1
      const shouldResetPage = pageSize !== tableParams.pagination.pageSize;

      const updatedTableParams = {
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: shouldResetPage ? 1 : current,
          pageSize,
        },
      };
      setParams(updatedTableParams);
      fetchData(updatedTableParams);
    },
    [tableParams, setParams, fetchData]
  );

  const handleTableChange = useCallback(
    (pagination, filters, sorter) => {
      console.log(sorter);
      const sortArray = Array.isArray(sorter) ? sorter : [sorter];

      const updatedTableParams = {
        ...tableParams,

        sort: sortArray,
      };
      setParams(updatedTableParams);
      fetchData(updatedTableParams);
    },
    [tableParams, setParams, fetchData]
  );

  return {
    handlePaginationChange,
    handleTableChange,
  };
};
